<template>
  <div class="app has-tab-menu report">
    <div class="header">
      <menutabs :state="{tabs: tabs}" :tab-selected="tabSelected" @tab-select="updateSelectedView"></menutabs>
    </div>
    <component v-if="tabSelected" :is="tabSelected.view"/>
  </div>
</template>

<script>


import reportworktimeoverview from '../reportcontext/ReportWorktimeoverview.vue'
import reportnoticeofresignation from '../reportcontext/ReportNoticeOfResignation.vue'
import reportstaffexpenses from '../reportcontext/ReportStaffExpenses.vue'
import reportcorrectioneventlog from './ReportCorrectionEventlog.vue'
import reportaccountingperiod from './ReportAccountingPeriod.vue'
import reportweekendsoffoverview from './ReportWeekendsOffOverview.vue'
import reportharaldfaschingspecial from './ReportHaraldFaschingSpecial.vue'
import reportovertimeoverview from '../reportcontext/ReportOvertimeoverview.vue'

import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    reportworktimeoverview,
    reportnoticeofresignation,
    reportstaffexpenses,
    reportcorrectioneventlog,
    reportaccountingperiod,
    reportweekendsoffoverview,
    reportharaldfaschingspecial,
    reportovertimeoverview,
  },
  name: 'PreferenceMain',
  data() {
    return {
      loading: true,
      tabSelected: null,
    }
  },
  watch: {},
  computed: {
    ...mapGetters([ 'storeId', 'isSuperUser', 'storeSettings', 'permissions' ]),
    canSeeStaffExpenses() {
      let val = false;
      Object.values(this.permissions).forEach(perms => {
        let perm = perms.find(p => p.id == 38);
        if (perm && perm.level > 2) { //permission to read reports
          val = true;
        }
      });
      return val;
    },
    tabs() {
      let schwerlaStoreIds = [ 6, 7, 8, 9, 10, 31, 32, 40, 41, 63, 176, 177, 178, 179, 205, 206, 207, 208 ];
      let hfaStoreIds = [ 85, 86, 506];
      let delFrateStoreIds = [155, 156, 157, 158, 159, 160, 161, 162, 163, 88, 211]
      let koeckStoreIds = [74, 76];
      let storeId = this.storeSettings.id;
      let tabs = [
        { label: this.$t('report.main.workTimeOverview'), view: 'reportworktimeoverview', margin: true },
        { label: this.$t('report.main.exitNotice'), view: 'reportnoticeofresignation', margin: true },
      ];
      if (this.isSuperUser || this.canSeeStaffExpenses) {
        tabs.push({ label: this.$t('report.main.staffCompensation'), view: 'reportstaffexpenses', margin: true })
      }
      tabs.push({ label: this.$t('report.main.mzCorrections'), view: 'reportcorrectioneventlog', margin: true })
      
      if(this.storeSettings.country == 1){
        tabs.push({label: this.$t('report.main.overtimeOverview'), view: 'reportovertimeoverview', margin: true, 'onlyAdmin' : this.storeSettings.country != 1});
      }else if(this.isSuperUser){
        tabs.push({label: this.$t('report.main.overtimeOverview'), view: 'reportovertimeoverview', margin: true, 'onlyAdmin' : true});
      }

      tabs.push({ label: this.$t('store.templates.freeWeekends'), view: 'reportweekendsoffoverview', margin: true })

      if (this.isSuperUser || schwerlaStoreIds.includes(storeId) || hfaStoreIds.includes(storeId) || delFrateStoreIds.includes(storeId) || koeckStoreIds.includes(storeId)) {
        tabs.push({ label: this.$t('report.main.accountingPeriod'), view: 'reportaccountingperiod', margin: true })
      }
      if (this.isSuperUser || hfaStoreIds.includes(storeId)) {
        tabs.push({ label: 'HFA', view: 'reportharaldfaschingspecial', margin: true })
      }


      return tabs;
    },
  },
  props: [ 'view', 'currentDay' ],
  created() {
  },
  mounted() {
    const tabFromRoute = this.$router.currentRoute.params.tab;
    if (tabFromRoute) {
      let tab = this.tabs.find(t => t.view === tabFromRoute);
      if (tab) this.tabSelected = tab;
      else this.updateSelectedView(this.tabs[0]);
    } else {
      let tab = this.tabs.find(t => t.selected);
      if (tab) this.tabSelected = tab;
      else this.tabSelected = this.tabs[0];
    }
  },

  updated() {
  },
  destroyed() {
  },
  methods: {
    updateSelectedView(tab) {
      if (tab.selected) return;
      this.tabs.forEach(t => t.selected = false);
      tab.selected = true;
      this.tabSelected = tab;
      this.$router.push('/reports/' + tab.view);
    },
  },
}
</script>
